import { gql } from "@apollo/client";
import { messageHeaders } from "features/common/fragments";
import { print } from "features/insuranceDocument/queries/fragments";
import { exportOutput } from "./fragments";

export const DOCUMENT_EXPORTED = gql`
  subscription documentExported {
    documentExported {
      exportOutput {
        ...exportOutput
      }
      silentMode
      headers {
        ...messageHeaders
      }
    }
  }
  ${exportOutput}
  ${messageHeaders}
`;

export const DOCUMENT_EXPORT_FAILED = gql`
  subscription documentExportFailed {
    documentExportFailed {
      errorMessage
      templateName
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const PRINTS_RETRIEVED = gql`
  subscription documentPrintsRetrieved($documentId: Int!) {
    documentPrintsRetrieved(documentId: $documentId) {
      printData {
        documentId
        prints {
          ...print
        }
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${print}
  ${messageHeaders}
`;

export const PRINTS_UPDATED = gql`
  subscription documentPrintsUpdated($documentId: Int!) {
    documentPrintsUpdated(documentId: $documentId) {
      printData {
        documentId
        prints {
          ...print
        }
        silentMode
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${print}
  ${messageHeaders}
`;

export const PRINT_UPDATED = gql`
  subscription documentPrintUpdated($documentId: Int!) {
    documentPrintUpdated(documentId: $documentId) {
      documentId
      print {
        ...print
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${print}
  ${messageHeaders}
`;

export const REQUEST_SIGNATURE_COMPLETED = gql`
  subscription requestSignatureCompleted {
    requestSignatureCompleted {
      documentId
      errorMessage
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const DOCUMENTS_SIGNED = gql`
  subscription documentsSigned {
    documentsSigned {
      documentId
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;
